import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Position } from '@xyflow/react';
import ActionHandle from '../ActionHandle';
import { ActionShowSingleScreenNodeType } from '../types';
import BaseNode from '../BaseNode';

export const ActionShowSingleScreenNode = memo(
  ({
    data,
    selected,
    disabled,
  }: {
    data: ActionShowSingleScreenNodeType['data'];
    selected?: boolean;
    disabled?: boolean;
  }) => {
    const intl = useIntl();
    return (
      <BaseNode
        selected={selected ?? false}
        type="action"
        isValid={data.isValid}
        disabled={disabled}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'Show Slide',
              id: 'LH3xoj',
            })}
          </T>
          <T body2>
            {data.options.genericKey ||
              intl.formatMessage({
                defaultMessage: 'Default',
                id: 'lKv8ex',
              })}
          </T>
        </Flex>
        <ActionHandle
          type="target"
          position={Position.Left}
          disabled={disabled}
        />
        <ActionHandle
          type="source"
          position={Position.Right}
          disabled={disabled}
        />
      </BaseNode>
    );
  },
);
